import React from 'react'

const ViewsIcon = (props: any = {}) => {
    return (
        <svg width="30" height="30" {...props} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="15" fill="#B380F7" />
            <path fillRule="evenodd" clipRule="evenodd" d="M17.3672 15.0434C17.3672 16.3529 16.3053 17.4141 14.9958 17.4141C13.6862 17.4141 12.625 16.3529 12.625 15.0434C12.625 13.7331 13.6862 12.6719 14.9958 12.6719C16.3053 12.6719 17.3672 13.7331 17.3672 15.0434Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14.9985 20.5155C17.8545 20.5155 20.4668 18.462 21.9375 15.039C20.4668 11.616 17.8545 9.5625 14.9985 9.5625H15.0015C12.1455 9.5625 9.53325 11.616 8.0625 15.039C9.53325 18.462 12.1455 20.5155 15.0015 20.5155H14.9985Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default ViewsIcon